/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * PlayerCallEntityBase
 * auto generated base class for the model PlayerCallEntityModel.
 */
export const PlayerCallEntityModelBase = ModelBase.named('PlayerCallEntity')
  .props({
    __typename: types.optional(types.literal('PlayerCallEntity'), 'PlayerCallEntity'),
    _id: types.identifier,
    channelName: types.union(types.undefined, types.string),
    createdAt: types.union(types.undefined, types.frozen()),
    isPlayerMuted: types.union(types.undefined, types.boolean),
    isPlayerOnAudioCall: types.union(types.undefined, types.boolean),
    isPlayerOnVideoCall: types.union(types.undefined, types.boolean),
    updatedAt: types.union(types.undefined, types.frozen()),
    userId: types.union(types.undefined, types.null, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlayerCallEntityModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get channelName() {
    return this.__attr('channelName')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get isPlayerMuted() {
    return this.__attr('isPlayerMuted')
  }
  get isPlayerOnAudioCall() {
    return this.__attr('isPlayerOnAudioCall')
  }
  get isPlayerOnVideoCall() {
    return this.__attr('isPlayerOnVideoCall')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get userId() {
    return this.__attr('userId')
  }
}
export function selectFromPlayerCallEntity() {
  return new PlayerCallEntityModelSelector()
}

export const playerCallEntityModelPrimitives =
  selectFromPlayerCallEntity()._id.channelName.createdAt.isPlayerMuted.isPlayerOnAudioCall.isPlayerOnVideoCall.updatedAt
    .userId
